import { t } from '@/utility/localization';

export const LEARN_MORE_ABT_CM_PAYOUT_HREF =
  'https://help.nas.io/en/articles/6768649-how-do-i-see-my-payments-and-payouts#h_baefc110aa';

export const EARNINGS_TAB = 'Earnings';
export const PAYOUT_TAB = 'Payout';
export const TRANSACTIONS_TAB = 'Transactions';

export const FEES_TAB = 'Fees';

export const getMoneyTabs = () => [
  {
    id: EARNINGS_TAB,
    label: t('earnings'),
    testId: 'c-moneypageTab-earnings',
    eventName: 'money_page_earnings_tab_clicked',
    checkAccessWithUserData: (user) => {
      return !user || !user.config || !user.config.hideEarning;
    }
  },
  {
    id: TRANSACTIONS_TAB,
    label: t('transactions'),
    testId: 'c-moneypageTab-transactions',
    eventName: 'money_page_transactions_tab_clicked',
    checkAccessWithUserData: (user) => {
      return !user || !user.config || !user.config.hideTransaction;
    }
  },
  {
    id: PAYOUT_TAB,
    label: t('payout'),
    testId: 'c-moneypageTab-payout',
    eventName: 'money_page_payout_tab_clicked',
    checkAccessWithUserData: (user) => {
      return !user || !user.config || !user.config.hidePayout;
    }
  },
  {
    id: FEES_TAB,
    label: t('fees'),
    testId: 'c-moneypageTab-fees',
    eventName: 'money_page_fees_tab_clicked',
    checkAccessWithUserData: () => {
      return true;
    }
  }
];

export default () => {
  const transactionTypes = {
    ALL: 'ALL',
    MEMBERSHIP: 'SUBSCRIPTION',
    EVENT: 'EVENT',
    FOLDER: 'FOLDER',
    CAMPAIGN_REWARD: 'CAMPAIGN_REWARD',
    REFERRAL_BONUS: 'REFERRAL_BONUS',
    SESSION: 'SESSION',
    CHALLENGE: 'CHALLENGE',
    ADJUSTMENT_ADD: 'ADJUSTMENT_ADD',
    ADJUSTMENT_DEDUCT: 'ADJUSTMENT_DEDUCT'
  };

  const transactionTypeFilters = [
    {
      label: t('all'),
      value: transactionTypes.ALL
    },
    {
      label: t('membership'),
      value: transactionTypes.MEMBERSHIP
    },
    {
      label: t('events'),
      value: transactionTypes.EVENT
    },
    {
      label: t('digital-product'),
      value: transactionTypes.FOLDER
    },
    {
      label: t('1-1-session-0'),
      value: transactionTypes.SESSION
    },
    {
      label: t('challenge'),
      value: transactionTypes.CHALLENGE
    }
  ];

  const transactionTypeAllOption = transactionTypeFilters.find(
    (txnType) => txnType.value === transactionTypes.ALL
  );

  const transactionTimeFilters = {
    ALL: 'ALL',
    LAST_7_DAYS: 'LAST_7_DAYS',
    CURRENT_MONTH: 'CURRENT_MONTH',
    LAST_MONTH: 'LAST_MONTH',
    CURRENT_YEAR: 'CURRENT_YEAR',
    CUSTOM: 'CUSTOM'
  };

  const transactionTimeFiltersOptions = [
    {
      label: t('last-7-days'),
      value: transactionTimeFilters.LAST_7_DAYS
    },
    {
      label: t('this-month'),
      value: transactionTimeFilters.CURRENT_MONTH
    },
    {
      label: t('last-month'),
      value: transactionTimeFilters.LAST_MONTH
    },
    {
      label: t('this-year'),
      value: transactionTimeFilters.CURRENT_YEAR
    },
    {
      label: t('all-time'),
      value: transactionTimeFilters.ALL
    },
    {
      label: t('custom-range'),
      value: transactionTimeFilters.CUSTOM,
      useCustomLabel: true
    }
  ];

  const transactionTimeAllOption = transactionTimeFiltersOptions.find(
    (timeFilter) => timeFilter.value === transactionTimeFilters.ALL
  );

  const transactionTimeCustomOption = transactionTimeFiltersOptions.find(
    (timeFilter) => timeFilter.value === transactionTimeFilters.CUSTOM
  );

  const transactionTableDataFields = [
    {
      label: t('title'),
      customWidth: '200px'
    },
    {
      label: t('member'),
      customWidth: '100px'
    },
    {
      label: t('date1'),
      customWidth: '70px',
      toolTip: t('reports-are-in-utc-time')
    },
    {
      icon: 'info-circle',
      label: t('balance'),
      customWidth: '70px'
    }
  ];

  const payoutsTableDataFields = [
    {
      label: t('month'),
      customWidth: '200px'
    },
    {
      label: t('status'),
      customWidth: '120px'
    },
    {
      label: t('amount'),
      customWidth: '120px'
    },
    {
      label: t('date1'),
      customWidth: '120px'
    }
  ];

  const oneTimeTableDataFields = [
    {
      label: t('title'),
      customWidth: '300px'
    },
    {
      label: t('price'),
      customWidth: '100px'
    },
    {
      label: t('sales'),
      key: 'sales',
      customWidth: '70px',
      sortable: true
    },
    {
      label: t('earnings'),
      key: 'earning',
      customWidth: '120px',
      sortable: true
    }
  ];

  const discountFaqSectionProps = [
    {
      answer: t(
        'you-can-create-discount-codes-when-creating-an-event-creating-a-content-folder-in-the-library-or-for-memberships-in-settings'
      ),
      question: t('how-can-i-create-a-discount-code')
    },
    {
      answer: t(
        'active-discount-codes-can-be-used-by-your-members-to-avail-discounts-for-their-purchases-inactive-discount-codes-can-no-longer-be-used-for-new-purchases-however-if-used-once-for-paid-membership-those-members-will-continue-to-enjoy-the-discounted-recurring-price'
      ),
      question: t(
        'what-is-the-difference-between-an-active-and-inactive-discount-code'
      )
    },
    {
      answer: t(
        'you-can-simply-click-the-3-dot-button-and-disable-the-discount-disabling-it-will-make-the-discount-code-inactive-and-no-new-purchases-will-be-able-to-apply-that-discount'
      ),
      question: t('how-can-i-stop-offering-a-discount-code')
    },
    {
      answer: t(
        'nas-io-supports-percentage-based-discounts-that-automatically-apply-for-all-supported-local-currencies'
      ),
      question: t(
        'how-can-i-offer-localized-discounts-for-my-global-members'
      )
    },
    {
      noLink: true,
      answer: t(
        'your-discount-codes-automatically-apply-to-all-subscription-intervals-offered'
      ),
      question: t(
        'how-do-my-discounts-work-for-different-subscription-intervals-such-as-annual-or-quarterly'
      )
    }
  ];

  const payoutsFaqSectionProps = [
    {
      question: t('how-often-will-i-get-my-payout'),
      answer: t('nas-io-payout-faq-answer-1')
    },
    {
      question: t(
        'why-didnt-i-get-my-payout-when-i-earned-money-last-month'
      ),
      answer: t('nas-io-payout-faq-2')
    },
    {
      question: t('how-to-set-up-my-bank-details'),
      answer: t('nas-io-payout-faq-3')
    },
    {
      question: t(
        'why-is-my-earnings-different-from-the-amount-in-the-payout-tab'
      ),
      answer: t('nas-io-payout-faq-4')
    },
    {
      question: t(
        'why-is-my-earnings-balance-different-from-how-much-i-supposed-to-receive'
      ),
      answer: t('payout-faq-13')
    },
    {
      question: t(
        'where-do-i-see-the-breakdown-of-processing-fees-deductions-before-my-payout-amount'
      ),
      answer: t('nas-io-payout-faq-5')
    },
    {
      question: t('what-will-be-the-currency-of-my-payout'),
      answer: t('nas-io-payout-faq-7')
    },
    {
      question: t(
        'where-can-i-obtain-a-payment-advice-to-serve-as-proof-that-the-payment-has-been-dispatched'
      ),
      answer: t('nas-io-payout-faq-8')
    },
    {
      question: t(
        'i-need-an-invoice-for-tax-purposes-where-can-i-obtain-the-invoice'
      ),
      answer: t('nas-io-payout-faq-9')
    },
    {
      question: t('can-i-change-my-bank-details-after-i-have-added-them'),
      answer: t('nas-io-payout-faq-10')
    },
    {
      question: t('nas-io-payout-faq-q-1'),
      answer: t('nas-io-payout-faq-11')
    },
    {
      question: t(
        'is-paypal-accepted-as-a-payment-method-my-bank-account-cannot-receive-international-payments'
      ),
      answer: t('nas-io-payout-faq-12')
    }
  ];

  const revenueTypes = [
    {
      title: t('membership'),
      id: 'membership'
    },
    {
      title: t('one-time-purchases'),
      id: 'oneTime'
    }
  ];

  const transactionType = {
    OUTBOUND: 'OUTBOUND',
    INBOUND: 'INBOUND'
  };
  return {
    transactionTypes,
    transactionTypeAllOption,
    payoutsFaqSectionProps,
    payoutsTableDataFields,
    transactionTypeFilters,
    transactionTimeFilters,
    transactionTimeFiltersOptions,
    transactionTimeAllOption,
    transactionTimeCustomOption,
    transactionTableDataFields,
    oneTimeTableDataFields,
    discountFaqSectionProps,
    revenueTypes,
    transactionType
  };
};
